export const useAudioStore = defineStore('audio', {
  state: () => ({
    audioContext: null,
    audioBuffers: {}, // all loaded audios stored by key
    currentSources: {}, // keep track of currently playing sources
    audioList: {
      noRevive: '/audio/game-over-no-revive.mp3',
      achievement: '/audio/achievement-unlocked-toast.mp3',
      dailyReward: '/audio/daily-reward.mp3',
      leaderBoard: '/audio/leaderboard-reward.mp3',
      idleReward: '/audio/idle-reward.mp3',
      powerUp: '/audio/power-up-purchase.mp3',
      successRevive: '/audio/revive-used.mp3',
      resumeGame: '/audio/pause-resume-countdown.mp3',
      navbarSound: '/audio/nav-bar-click.mp3',
      successUpgrade: '/audio/upgrade-successful.mp3',
      spinWheel: '/audio/spin-wheel.wav',
      globalError: '/audio/general-error.ogg',
      globalSuccess: '/audio/general-success.ogg',
      noInventory: '/audio/no-inventory.mp3',
      successPurchase: '/audio/stars-purchase.mp3',
      upgradeAvailable: '/audio/upgrade-available.mp3',
    },
    rewardAudios: {
      ticket: '/audio/ticket-reward-spin.mp3',
      gem: '/audio/gem-reward-spin.mp3',
      tether: '/audio/tether-reward-spin.mp3',
      coin: '/audio/coin-received-spin.mp3',
    },
  }),

  getters: {
    // Merge all audios (main + reward)
    allAudios: (state) => ({
      ...state.audioList,
      ...state.rewardAudios,
    }),
  },

  actions: {
    initAudioContext() {
      if (!this.audioContext) {
        this.audioContext = new (window.AudioContext ||
          window.webkitAudioContext)()
      }
    },

    async loadAudio(key, url) {
      this.initAudioContext()
      try {
        const response = await fetch(url)
        const arrayBuffer = await response.arrayBuffer()
        const decoded = await this.audioContext.decodeAudioData(arrayBuffer)
        this.audioBuffers[key] = decoded
      } catch (err) {
        this.audioBuffers[key] = null
        Sentry.captureException(err)
      }
    },

    async preloadAll() {
      this.initAudioContext()
      const promises = Object.entries(this.allAudios).map(([key, url]) =>
        this.loadAudio(key, url),
      )
      await Promise.all(promises)
    },

    playSound(key, rate = 1.0) {
      try {
        if (!this.audioBuffers[key] || !this.audioContext) return
        const source = this.audioContext.createBufferSource()
        source.buffer = this.audioBuffers[key]
        source.playbackRate.value = rate
        source.connect(this.audioContext.destination)
        source.start()

        // Store reference to allow stopping later
        this.currentSources[key] = source

        // Clean up when finished playing
        source.onended = () => {
          if (this.currentSources[key] === source) {
            delete this.currentSources[key]
          }
        }
      } catch (err) {
        Sentry.captureException(err)
      }
    },

    stop(key) {
      try {
        if (key && this.currentSources[key]) {
          this.currentSources[key].stop()
          delete this.currentSources[key]
        } else if (!key) {
          // Stop all currently playing sounds
          Object.values(this.currentSources).forEach((source) => source.stop())
          this.currentSources = {}
        }
      } catch (err) {
        Sentry.captureException(err)
      }
    },
  },
})
